import { ColorsDTO } from '../types';

export const createColorsDTO = (entry?: Partial<ColorsDTO>): ColorsDTO => {
  return {
    primary: entry?.primary || '',
    secondary: entry?.secondary || '',
  };
};
